import { Route, Redirect } from "react-router-dom";
import React, { Suspense, lazy, Fragment, useState } from "react";
import Loader from "react-loaders";
import { useSelector } from 'react-redux';
import { ToastContainer } from "react-toastify";
const board = lazy( () => import("../../components"));
const Caja = lazy(() => import("../../components/Apps/Accounting/Accounting"));

const AppMain = () => {
  return (
    <Fragment>
      <Suspense style={{fontSize: ''}}
        fallback={
          <div className="loader-container">
            <div className="loader-container-inner">
              <div className="text-center">
                <Loader type="ball-pulse-rise" />
              </div>
            </div>
          </div>
        }
      >
        <Route path="/contabilidad/caja-chica/trans" component={Caja} />
      </Suspense>
      <Suspense
        fallback={
          <div className="loader-container">
            <div className="loader-container-inner">
              <div className="text-center">
                <Loader type="ball-pulse-rise" />
              </div>
            </div>
          </div>
        }
      >
        <Route path="/contabilidad/caja-chica/approvals" component={Caja} />
      </Suspense>
      <Suspense
        fallback={
          <div className="loader-container">
            <div className="loader-container-inner">
              <div className="text-center">
                <Loader type="ball-pulse-rise" />
              </div>
            </div>
          </div>
        }
      >
      <Route path="/principal" component={board} />
      </Suspense>
      <Route exact path="/" render={() => <Redirect to="/principal" />} />
      <ToastContainer />
    </Fragment>
  );
};



export default AppMain;
